import React, { useEffect, useState } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, LinearProgress, Typography } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { useAppDispatch } from '../hooks';

const SPINNER_TICK_INTERVAL = 255;
const SIMULATED_SPINNER_LENGTH = 9000;

export function BearingImageUploadDialog(props: { imageUrl: string }) {
  const dispatch = useAppDispatch();

  const [simulatedStage, setSimulatedStage] = useState(0);
  const [simulatedProgress, setSimulatedProgress] = useState(0);

  useEffect(() => {
    if (simulatedStage === 1 || simulatedStage === 2) {
      const handle = setInterval(() => {
        setSimulatedProgress((progress) => progress + (SPINNER_TICK_INTERVAL / SIMULATED_SPINNER_LENGTH) * 100);
      }, SPINNER_TICK_INTERVAL);

      return () => {
        clearInterval(handle);
      };
    }
  }, [simulatedStage]);

  useEffect(() => {
    if (simulatedStage === 1) {
      const spinnerAdvancementTimeout = setTimeout(() => {
        setSimulatedStage(2);
        setSimulatedProgress(0);
      }, SIMULATED_SPINNER_LENGTH);

      return () => {
        clearTimeout(spinnerAdvancementTimeout);
      };
    }
  }, [simulatedStage]);

  function closeDialog() {
    dispatch(closeCurrentPopup());
  }

  if (simulatedStage === 0)
    return (
      <Dialog
        insistent
        variant="design"
        title="Upload Image for Wall Creation"
        cancelText="Close"
        onCancel={closeDialog}
        submitText="Upload"
        onSubmit={() => {
          setSimulatedStage(1);
        }}
      >
        <img src={props.imageUrl} width="600" />
      </Dialog>
    );

  return (
    <Dialog insistent variant="design" submitDisabled cancelText="Close" onCancel={closeDialog}>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        {simulatedStage === 1 ? (
          <CloudUploadIcon sx={{ fontSize: '96px' }} />
        ) : (
          <AutoAwesomeIcon sx={{ fontSize: '96px' }} />
        )}
      </Box>

      <Typography sx={{ marginY: 2 }}>
        {simulatedStage === 1 ? 'Uploading image for processing...' : 'Analyzing and extracting walls...'}
      </Typography>

      {/* keys are important so animation resets to 0 cleanly between stages */}
      {simulatedProgress > 100 ? (
        <LinearProgress key={`${simulatedStage}-indeterminate`} />
      ) : (
        <LinearProgress key={`${simulatedStage}-determinate`} variant="determinate" value={simulatedProgress} />
      )}
    </Dialog>
  );
}
